import { ScriptEditorPage } from '@/features/studio/pages/production/ScriptEditorPage'

export function WriterScriptEditorPage() {
  return <ScriptEditorPage variant="personal" />
}
